import { render, staticRenderFns } from "./TemplateParams.vue?vue&type=template&id=59ac941c&"
import script from "./TemplateParams.vue?vue&type=script&lang=ts&"
export * from "./TemplateParams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports